/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Sound_BellInputs */

const en_us2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bell`)
};

const pt_br2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sino`)
};

const es_419_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campana`)
};

const pt_pt2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sino`)
};

const fr_fr2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloche`)
};

const de_de2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glocke`)
};

const it_it2_workout_logging_sound_bell = /** @type {(inputs: Workout_Logging_Sound_BellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanella`)
};

/**
* | output |
* | --- |
* | "Bell" |
*
* @param {Workout_Logging_Sound_BellInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_sound_bell = /** @type {((inputs?: Workout_Logging_Sound_BellInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Sound_BellInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_sound_bell(inputs)
	if (locale === "es-419") return es_419_workout_logging_sound_bell(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_sound_bell(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_sound_bell(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_sound_bell(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_sound_bell(inputs)
	return en_us2_workout_logging_sound_bell(inputs)
});
export { workout_logging_sound_bell as "workout-logging.sound_bell" }